import './ChangePasswordPage.css';

import { NavLink, Redirect } from 'react-router-dom';
import { changePassword, closeSavePasswordNotification, getResetPasswordEmail } from '../../stores/actions/accountActions';
import { emptyHeaderStyle, loaderStyle } from '../../helpers/CustomStyles';

import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooterTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Loading from '../../components/Loading/Loading';
import LockOutlined from '@material-ui/icons/LockOutlined';
import Logo from '../../assets/img/WISENE_logo_medium.png';
import React from 'react';
import Snackbar from '../../../components/Snackbar/Snackbar';
import TextField from '@material-ui/core/TextField';
import changePasswordPageStyle from '../../assets/jss/views/loginPageStyleTS';
import { connect } from 'react-redux';
import utils from '../../helpers/GlobalVariables';

interface IChangePasswordCredentials {
	token: string;
	password: string;
}

interface IChangePasswordPageProps {
	token: string;
	cardAnimation: string;
	resettingPasswordSucceed: boolean;
	resettingPasswordFailed: boolean;
	changedPasswordEmail: string;
	incorrectToken: boolean;
	classes: ClassNameMap;
	changePassword: (credentials: IChangePasswordCredentials) => void;
	getResetPasswordEmail: (token: string) => void;
	closeSavePasswordNotification: () => void;
}

interface IChangePasswordPageState {
	backButtonIsHover: boolean;
	saveButtonIsHover: boolean;
	saveButtonDisable: boolean;
	newPassword: string;
	changedEmail: string;
	goToLoginPage: boolean;
	isLoaderRender: boolean;
	passwordValue: string;
	passwordError: boolean;
	repeatPasswordValue: string;
	repeatPasswordError: boolean;
	passwordFocusOut: boolean;
	repeatPasswordFocusOut: boolean;
	repeatPasswordErrorSecond: boolean;
	mobileViewLocal: boolean;
}

class ChangePasswordPageTS extends React.Component<IChangePasswordPageProps, IChangePasswordPageState> {
	state = {
		backButtonIsHover: false,
		saveButtonIsHover: false,
		saveButtonDisable: true,
		newPassword: '',
		changedEmail: '',
		goToLoginPage: false,
		isLoaderRender: false,
		passwordValue: '',
		passwordError: false,
		repeatPasswordValue: '',
		repeatPasswordError: false,
		passwordFocusOut: false,
		repeatPasswordFocusOut: false,
		repeatPasswordErrorSecond: false,
		mobileViewLocal: false,
	};

	passwordRef = React.createRef<HTMLInputElement>();
	repeatPasswordRef = React.createRef<HTMLInputElement>();
	redirectTimeout: ReturnType<typeof setTimeout> = null;
	notificationTimer: ReturnType<typeof setTimeout> = null;

	onKeyDown = (event: KeyboardEvent): void => {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter' && !this.state.saveButtonDisable) {
			event.preventDefault();
			event.stopPropagation();
			this.setState({ isLoaderRender: true });
			this.submitForm();
		}
	};

	submitForm = (): void => {
		this.props.changePassword({
			token: window.location.pathname.split('/')[3],
			password: this.state.passwordValue,
		});
	};

	onResize = (): void => {
		if (window.innerWidth < 800) {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: true }));
		} else {
			this.setState((prevState) => ({ ...prevState, mobileViewLocal: false }));
		}
	};

	componentDidMount() {
		const {
			resettingPasswordFailed,
			resettingPasswordSucceed,
			getResetPasswordEmail,
			incorrectToken,
			closeSavePasswordNotification,
			changedPasswordEmail,
		} = this.props;

		if (resettingPasswordFailed || resettingPasswordSucceed) {
			return closeSavePasswordNotification();
		}
		window.addEventListener('resize', this.onResize);
		window.addEventListener('keydown', this.onKeyDown);
		this.passwordRef.current.addEventListener('focusout', this.onFocusOut);
		this.repeatPasswordRef.current.addEventListener('focusout', this.onFocusOut);
		this.onResize();
		const token = window.location.pathname.split('/')[3];
		getResetPasswordEmail(token);
		if (!incorrectToken) {
			this.setState({ changedEmail: changedPasswordEmail });
		}
		this.setState({ isLoaderRender: false, goToLoginPage: false });
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		window.addEventListener('keydown', this.onKeyDown);
		clearTimeout(this.redirectTimeout);
		clearTimeout(this.notificationTimer);
	}

	componentDidUpdate() {
		this.handleSaveButtonDisable();
		const { resettingPasswordFailed, resettingPasswordSucceed, closeSavePasswordNotification } = this.props;

		if (resettingPasswordFailed || resettingPasswordSucceed) {
			clearTimeout(this.notificationTimer);
			this.notificationTimer = setTimeout(() => {
				closeSavePasswordNotification();
				this.setState({ isLoaderRender: false });
			}, 6000);
			this.redirectTimeout = setTimeout(() => {
				this.setState({ goToLoginPage: true });
			}, 7000);
		}
	}

	handleSaveButtonDisable = (): void => {
		const {
			passwordValue,
			repeatPasswordValue,
			passwordError,
			repeatPasswordError,
			repeatPasswordErrorSecond,
			saveButtonDisable,
		} = this.state;
		if (passwordValue === '' || repeatPasswordValue === '' || passwordError || repeatPasswordError || repeatPasswordErrorSecond) {
			if (!saveButtonDisable) {
				this.setState({ saveButtonDisable: true });
			}
		} else {
			if (saveButtonDisable) {
				this.setState({ saveButtonDisable: false });
			}
		}
	};

	backButtonToggleHover = () => {
		this.setState({ backButtonIsHover: !this.state.backButtonIsHover });
	};

	savePasswordToggleHoverOn = () => {
		this.setState({ saveButtonIsHover: true });
	};

	savePasswordToggleHoverOff = () => {
		this.setState({ saveButtonIsHover: false });
	};

	handleInputChange = (e): void => {
		const currentValue = e.target.value;
		const currentName = e.target.id;
		const { passwordFocusOut, repeatPasswordFocusOut, passwordValue, repeatPasswordValue } = this.state;

		if (passwordFocusOut && currentName === 'password') {
			if (currentValue === '') {
				this.setState({ passwordError: true });
			} else {
				this.setState({ passwordError: false });
			}
			if (repeatPasswordFocusOut) {
				if (currentValue !== repeatPasswordValue) {
					this.setState({ repeatPasswordErrorSecond: true });
				} else {
					this.setState({ repeatPasswordErrorSecond: false });
				}
			}
		}

		if (repeatPasswordFocusOut && passwordFocusOut && currentName === 'repeatPassword') {
			if (currentValue === '') {
				this.setState({ repeatPasswordError: true });
			} else {
				this.setState({ repeatPasswordError: false });
			}
			if (passwordValue !== currentValue) {
				this.setState({ repeatPasswordErrorSecond: true });
			} else {
				this.setState({ repeatPasswordErrorSecond: false });
			}
		}

		this.setState((state) => ({ ...state, [currentName + 'Value']: currentValue }));
	};

	onFocusOut = (e): void => {
		const currentName = e.target.id;
		this.setState((state) => ({ ...state, [currentName + 'FocusOut']: true }));
		this.handleInputChange(e);
	};

	handleSaveButtonClick = (): void => {
		this.setState({ isLoaderRender: true });
		this.submitForm();
	};

	renderMobileNotifications = (): JSX.Element => {
		const { mobileViewLocal } = this.state;
		const { incorrectToken, resettingPasswordSucceed } = this.props;
		const headerStyle = utils.getHeaderStyle(incorrectToken);

		if (mobileViewLocal) {
			if (incorrectToken || resettingPasswordSucceed) {
				return (
					<h5
						className={
							incorrectToken ? 'notification-open-change-password-page-fail' : 'notification-open-change-password-page-success'
						}
						style={headerStyle}
					>
						{incorrectToken ? 'Incorrect token' : 'New password has been saved'}
					</h5>
				);
			}
			return <div style={emptyHeaderStyle}></div>;
		}
	};

	render() {
		const {
			classes,
			incorrectToken,
			changedPasswordEmail,
			resettingPasswordSucceed,
			resettingPasswordFailed,
			closeSavePasswordNotification,
		} = this.props;
		const {
			saveButtonIsHover,
			goToLoginPage,
			isLoaderRender,
			passwordValue,
			passwordError,
			repeatPasswordValue,
			repeatPasswordError,
			repeatPasswordErrorSecond,
			saveButtonDisable,
			mobileViewLocal,
		} = this.state;
		const gridStylePassword = { marginBottom: passwordError ? '10px' : '30px' };
		const gridStyleRepeatedPassword = {
			marginBottom: repeatPasswordError || repeatPasswordErrorSecond ? '10px' : '30px',
		};

		if (goToLoginPage) {
			return <Redirect from='/pages/change-password' to='/pages/login-page' />;
		} else {
			return (
				<div className={`${classes.container} change-password-page`}>
					<GridContainer justify='center' className='change-password-page-container' direction='column' alignItems='center'>
						<GridItem xs={10}>
							<img className='wisene-logo' src={Logo} alt='wisene logo'></img>
						</GridItem>
						<GridItem md={6} lg={6}>
							<Card login className={classes[this.props.cardAnimation]}>
								<form>
									<CardHeader className={`${classes.cardHeader} ${classes.textCenter}`} color='danger'>
										<h4 className={classes.cardTitle}>
											{`Change password`}
											{incorrectToken ? '' : ` for ${changedPasswordEmail}`}
										</h4>
									</CardHeader>
									<CardBody>
										<TextField
											label='New password'
											id='password'
											error={passwordError}
											helperText={passwordError ? 'Password can not be empty' : ''}
											fullWidth
											required
											disabled={incorrectToken || resettingPasswordSucceed || resettingPasswordFailed}
											style={gridStylePassword}
											inputProps={{ maxLength: utils.defaultMaxInputLength, autoCapitalize: 'off' }}
											InputProps={{
												value: passwordValue,
												onChange: (e) => this.handleInputChange(e),
												ref: this.passwordRef,
												type: 'password',
												endAdornment: (
													<InputAdornment position='end'>
														<LockOutlined className={classes.inputAdornmentIcon} />
													</InputAdornment>
												),
											}}
										/>
										<TextField
											label='Repeat new password'
											id='repeatPassword'
											error={repeatPasswordError || repeatPasswordErrorSecond}
											helperText={
												repeatPasswordError
													? 'Password can not be empty'
													: repeatPasswordErrorSecond
													? 'Passwords do not match'
													: ''
											}
											fullWidth
											required
											disabled={incorrectToken || resettingPasswordSucceed || resettingPasswordFailed}
											style={gridStyleRepeatedPassword}
											inputProps={{ maxLength: utils.defaultMaxInputLength, autoCapitalize: 'off' }}
											InputProps={{
												value: repeatPasswordValue,
												onChange: (e) => this.handleInputChange(e),
												ref: this.repeatPasswordRef,
												type: 'password',
												endAdornment: (
													<InputAdornment position='end'>
														<LockOutlined className={classes.inputAdornmentIcon} />
													</InputAdornment>
												),
											}}
										/>
										<GridItem xs={12} style={{ padding: '0' }}>
											{this.renderMobileNotifications()}
										</GridItem>
										{isLoaderRender ? (
											<div style={loaderStyle}>
												<Loading transform={0.55} color='red' />
											</div>
										) : (
											<GridItem xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
												<Button
													id='savePasswordButton'
													color='danger'
													onClick={this.handleSaveButtonClick}
													simple
													size='lg'
													onMouseEnter={this.savePasswordToggleHoverOn}
													onMouseLeave={this.savePasswordToggleHoverOff}
													style={{
														transition: '0.2s',
														color: saveButtonIsHover ? 'rgb(182, 12, 0)' : '#f44336',
													}}
													disabled={saveButtonDisable}
												>
													Save
												</Button>
											</GridItem>
										)}
									</CardBody>
									<CardFooter className={classes.justifyContentCenter}>
										<GridItem xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
											<NavLink to={'/pages/login-page'} id='backButton'>
												Go to Login Page
											</NavLink>
										</GridItem>
									</CardFooter>
								</form>
							</Card>
						</GridItem>
					</GridContainer>
					{!mobileViewLocal ? (
						<>
							<Snackbar
								close={undefined}
								color='danger'
								message='Incorrect token.'
								open={incorrectToken || resettingPasswordFailed}
								place='tc'
							/>
							<Snackbar
								closeNotification={() => closeSavePasswordNotification()}
								color='success'
								message='New password has been saved successfully.'
								open={resettingPasswordSucceed}
								place='tc'
							/>
						</>
					) : null}
				</div>
			);
		}
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		cardAnimation: state.login.cardAnimation,
		resettingPasswordSucceed: state.login.resettingPasswordSucceed,
		resettingPasswordFailed: state.login.resettingPasswordFailed,
		changedPasswordEmail: state.login.changedPasswordEmail,
		incorrectToken: state.login.incorrectToken,
	};
};

const actions = {
	changePassword,
	getResetPasswordEmail,
	closeSavePasswordNotification,
};

const changePasswordWithStyles = changePasswordPageStyle(ChangePasswordPageTS);
export default connect(mapStateToProps, actions)(changePasswordWithStyles);
